import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import { Card, Row, Col, Alert, Button } from 'antd';
import { LoadingSpinner } from '../presentation/LoadingSpinner';
import { analytics } from '../modules/analytics';
// import { pageviewGA, eventGA } from '../modules/ganalytics';


export default class UserPlan extends React.Component {
  static propTypes = {
    plan: PropTypes.object.isRequired,
    getPlan: PropTypes.func.isRequired,
    selectPlan: PropTypes.func.isRequired,
    networkError: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    analytics.trackView('/user/plan');
    this.props.getPlan();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.networkError && !this.props.networkError) {
      this.props.getPlan();
    }
  }

  onSelectPlan = (plan) => {
    // eventGA({
    //   category: 'account',
    //   action: 'plan_selected',
    // });

    if (plan === 'plan_starter') {
      this.props.selectPlan('plan_starter');
    }
    else if (plan === 'plan_pro') {
      this.props.selectPlan('plan_pro');
    }
    else if (plan === 'plan_enterprise') {
      this.props.selectPlan('plan_enterprise');
    }
  };


  extractPlanDetails = (plan) => {
    const { trial_end, trial_start, billing_cycle_anchor } = plan;
    const { id } = plan.plan;
    let trialDaysRemaining = 0;
    let nextBillingDate = '';

    if (trial_end !== null) {
      const tstartDate = new Date(trial_start * 1000);
      const tendDate = new Date(trial_end * 1000);
      const timeDiff = Math.abs(tendDate.getTime() - tstartDate.getTime());
      trialDaysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    if (billing_cycle_anchor != null) {
      nextBillingDate = new Date(billing_cycle_anchor * 1000).toDateString();
    }

    return {
      isTrial: (trial_end !== null),
      trialDaysRemaining,
      currentPlan: id,
      nextBillingDate,
    };
  }

  extractCardsDetails = (cards) => {
    let isCardAdded = false;
    if ('data' in cards) {
      if (cards.data.length > 0) {
        isCardAdded = true;
      }
    }
    return {
      isCardAdded,
    };
  }

  render() {
    const { plan, cards, status, error_message } = this.props.plan;
    if (status === 'init') {
      return null;
    }
    if (status === 'loading') {
      return (
        <LoadingSpinner />
      );
    }

    const {
      isTrial,
      trialDaysRemaining,
      currentPlan,
      nextBillingDate,
    } = this.extractPlanDetails(plan);

    const { isCardAdded } = this.extractCardsDetails(cards);

    const cardStyleForPlan = (p) => {
      if (p === currentPlan) {
        return {
          border: '3px solid #52C41A',
          backgroundColor: '#52C41A1d',
        };
      }
      return {
        backgroundColor: '#D6DCE320',
      };
    };

    /*
    top plans should have a upgrade Button
    Lower plans will show button. Whne you click, the server would deny if within
    same billing cycle with an appropriate message. That message will have
    a contact customer support button which will be a mailto: href
    */

    const cardAddPrompt = (
      <React.Fragment>
        <Link to="/user/payment">Add a card</Link> to avoid service interruption beyond your trial period
      </React.Fragment>
    );

    const responsiveProps = {
      xs: 24,
      sm: { span: 18, offset: 3 },
      md: { span: 16, offset: 4 },
      lg: { span: 8, offset: 0 },
      xl: 6,
    };

    const planSelectButtonFor = (p) => {
      if (p === currentPlan) {
        return (
          <React.Fragment>
            <Button
              type="default"
              ghost
              disabled
              className="mt-3"
              style={{ width: '100%' }}
              icon="check"
            >
              Your Current Plan
            </Button>
            <div className="mt-2">
              Your next billing is on {nextBillingDate}
            </div>
          </React.Fragment>
        );
      }
      return (
        <Button
          type="primary"
          className="mt-3"
          style={{ width: '100%' }}
          onClick={() => this.onSelectPlan(p)}
        >
          Select
        </Button>
      );
    };

    return (
      <div>
        <Helmet>
          <title>My Plan</title>
        </Helmet>
        <h5 className="mb-4">Manage Your Plan</h5>

        {
          (currentPlan === 'plan_free') ? (
            <div className="mt-2 mb-3">
              You are on the free plan. Select a plan below to upgrade before your trial ends.
            </div>
          ) : null
        }

        {
          isTrial ? (
            <Alert
              message={`You have ${trialDaysRemaining} days remaining in your trial`}
              type="info"
              className="mb-3"
              closable={true}
            />
          ) : null
        }
        {
          error_message ? (
            <Alert
              message={
                <span>
                  {error_message}
                  <a href="mailto:support@pagehits.io">
                    <Button type="default" size="small">Click me</Button>
                  </a>
                </span>

              }
              type="error"
              className="mb-3"
              closable={true}
            />
          ) : null
        }
        {
          !isCardAdded ? (
            <Alert
              message={cardAddPrompt}
              type="warning"
              closable={true}
              className="mb-3"
            />
          ) : null
        }

        <Row gutter={16} className="mt-5">

          <Col {...responsiveProps} >
            <Card title="Enterprise" style={cardStyleForPlan('plan_enterprise')} className="mb-4">
              <div className="text-primary mb-3">$99/mo</div>
              <div className="text-secondary mb-3">Up to 10 million page views</div>
              {planSelectButtonFor('plan_enterprise')}
            </Card>
          </Col>

          <Col {...responsiveProps}>
            <Card title="Pro" style={cardStyleForPlan('plan_pro')} className="mb-4">
              <div className="text-primary mb-3">$49/mo</div>
              <div className="text-secondary mb-3">Up to 10K page views</div>
              {planSelectButtonFor('plan_pro')}
            </Card>
          </Col>

          <Col {...responsiveProps}>
            <Card title="Starter" style={cardStyleForPlan('plan_starter')} className="mb-4">
              <div className="text-primary mb-3">$19/mo</div>
              <div className="text-secondary mb-3">Up to 1K page views</div>
              {planSelectButtonFor('plan_starter')}
            </Card>
          </Col>

        </Row>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/UserPlan.jsx